import React from "react";
import { RaiseColors } from "componentLibrary/theme/RaiseColors";
import { IconConstants } from "componentLibrary/MuiComponentWrappers/Icon/IconConstants";
import classnames from "classnames";
import styles from "./PillSearchField.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var PillSearchField = function PillSearchField(_ref) {
  var onChange = _ref.onChange,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "Search" : _ref$placeholder,
    _ref$leadingIcon = _ref.leadingIcon,
    leadingIcon = _ref$leadingIcon === void 0 ? "fa-light fa-magnifying-glass" : _ref$leadingIcon,
    _ref$enableClear = _ref.enableClear,
    enableClear = _ref$enableClear === void 0 ? false : _ref$enableClear,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? null : _ref$value,
    _ref$borderColor = _ref.borderColor,
    borderColor = _ref$borderColor === void 0 ? RaiseColors.neutral300 : _ref$borderColor,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? RaiseColors.neutral100 : _ref$backgroundColor,
    _ref$hoverBorderColor = _ref.hoverBorderColor,
    hoverBorderColor = _ref$hoverBorderColor === void 0 ? RaiseColors.neutral500 : _ref$hoverBorderColor,
    _ref$activeBorderColo = _ref.activeBorderColor,
    activeBorderColor = _ref$activeBorderColo === void 0 ? RaiseColors.teal : _ref$activeBorderColo,
    _ref$activeBoxShadowC = _ref.activeBoxShadowColor,
    activeBoxShadowColor = _ref$activeBoxShadowC === void 0 ? "rgba(0, 166, 202, 0.08)" : _ref$activeBoxShadowC,
    _ref$placeholderColor = _ref.placeholderColor,
    placeholderColor = _ref$placeholderColor === void 0 ? RaiseColors.grayscale900 : _ref$placeholderColor,
    className = _ref.className,
    ariaLabel = _ref["aria-label"];
  var clearInput = function clearInput() {
    onChange({
      target: {
        value: ""
      }
    });
  };
  return /*#__PURE__*/_jsxs("label", {
    style: {
      "--border-color": borderColor,
      "--background-color": backgroundColor,
      "--hover-border-color": hoverBorderColor,
      "--active-border-color": activeBorderColor,
      "--active-box-shadow-color": activeBoxShadowColor,
      "--placeholder-color": placeholderColor
    },
    className: classnames(styles.searchFieldContainer, className),
    children: [leadingIcon ? /*#__PURE__*/_jsx("span", {
      className: classnames(leadingIcon, styles.leadingIcon)
    }) : null, /*#__PURE__*/_jsx("input", {
      type: "text",
      value: value || "",
      className: styles.searchField,
      placeholder: placeholder,
      onChange: onChange,
      "aria-label": ariaLabel
    }), enableClear && (value === null || value === void 0 ? void 0 : value.length) > 0 && /*#__PURE__*/_jsx("button", {
      type: "button",
      className: classnames(styles.xStyles, IconConstants.X),
      onClick: clearInput,
      "aria-label": "Clear search"
    })]
  });
};
export default PillSearchField;